import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../../common/assets/logo'

export default () => {
	const className = 'nav-logo'

	return (
		<Link className={className} to="/">
			<Logo blockClassName={className} />
		</Link>
	)
}


// WEBPACK FOOTER //
// ./src/desktop/components/nav-logo/index.js